import { Typography } from 'components/ui/typography';

const NoAccessPage = () => (
  <div className="mx-auto mt-20 max-w-lg text-center">
    <Typography variant="h2" as="h1">
      No accessible console sections
    </Typography>
    <Typography variant="small" as="p" className="mt-3">
      You don’t currently have access to any console sections. If you need access, please reach out
      to an administrator on your team to request the appropriate permissions.
    </Typography>
  </div>
);

export default NoAccessPage;
